import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/products/add-ons/create')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/products/create',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
